import React from 'react'
import Project from '../Layout/Project'

const ProjectPage = () => {
  return <Project />
}

export default ProjectPage
